// DISCIPLAY — Cookie Consent (GDPR opt-in, 7 locales)
// Reads/writes localStorage; dispatches `cookie-consent` events with current preferences.
// Consent-gated scripts listen for this event before they load.

(function () {
  'use strict';
  const KEY = 'ds4_cookie_consent_v1';
  const banner = document.querySelector('[data-cookie-banner]');
  if (!banner) {
    // Banner disabled in admin (settings.show_cookie_banner = false).
    // No UI to collect consent -> default to permissive so theme-managed
    // consent listeners can fire on page load.
    // Users can later re-open via the footer "Cookie preferences" link.
    // Respects any pre-existing saved choice; only auto-fires on first visit.
    try {
      const saved = JSON.parse(localStorage.getItem(KEY) || 'null');
      const prefs = saved || { essential: true, analytics: true, marketing: true };
      if (!saved) localStorage.setItem(KEY, JSON.stringify({ ...prefs, ts: new Date().toISOString() }));
      window.dispatchEvent(new CustomEvent('cookie-consent', { detail: prefs }));
      // Also perform the data-src → src swap that the listener at the
      // bottom of this file would normally do. We early-return below and
      // never reach it, so deferred scripts would otherwise stay inert.
      if (prefs.analytics) {
        document.querySelectorAll('script[data-consent="analytics"][data-src]').forEach((s) => {
          if (!s.src) s.src = s.dataset.src;
        });
      }
      if (prefs.marketing) {
        document.querySelectorAll('script[data-consent="marketing"][data-src]').forEach((s) => {
          if (!s.src) s.src = s.dataset.src;
        });
      }
    } catch (e) { /* localStorage unavailable, skip */ }
    return;
  }

  const cats = banner.querySelector('[data-cookie-categories]');
  const acceptAllBtn = banner.querySelector('[data-cookie-accept-all]');
  const rejectBtn    = banner.querySelector('[data-cookie-reject]');
  const customizeBtn = banner.querySelector('[data-cookie-customize]');
  const saveBtn      = banner.querySelector('[data-cookie-save]');

  function load() {
    try { return JSON.parse(localStorage.getItem(KEY) || 'null'); }
    catch { return null; }
  }
  function persist(prefs) {
    const obj = { essential: true, analytics: !!prefs.analytics, marketing: !!prefs.marketing, ts: new Date().toISOString() };
    localStorage.setItem(KEY, JSON.stringify(obj));
    window.dispatchEvent(new CustomEvent('cookie-consent', { detail: obj }));
    hide();
    return obj;
  }
  function hide() { banner.setAttribute('hidden', ''); banner.classList.remove('is-expanded'); }
  function show() { banner.removeAttribute('hidden'); }
  function expand() {
    cats.removeAttribute('hidden');
    banner.classList.add('is-expanded');
    saveBtn.removeAttribute('hidden');
    customizeBtn.setAttribute('hidden', '');
  }

  // Mount: hide if already saved, otherwise show after 600ms
  const saved = load();
  if (saved) {
    hide();
    // Fire event so loaders mounted later still get the current state
    setTimeout(() => window.dispatchEvent(new CustomEvent('cookie-consent', { detail: saved })), 0);
  } else {
    setTimeout(show, 600);
  }

  acceptAllBtn?.addEventListener('click', () => persist({ analytics: true, marketing: true }));
  rejectBtn   ?.addEventListener('click', () => persist({ analytics: false, marketing: false }));
  customizeBtn?.addEventListener('click', expand);
  saveBtn     ?.addEventListener('click', () => {
    const prefs = { analytics: false, marketing: false };
    cats.querySelectorAll('input[type=checkbox]').forEach((cb) => {
      if (cb.name === 'analytics') prefs.analytics = cb.checked;
      if (cb.name === 'marketing') prefs.marketing = cb.checked;
    });
    persist(prefs);
  });

  // Category toggle (click anywhere on a .cookie-cat label flips the hidden checkbox)
  cats?.addEventListener('click', (e) => {
    const label = e.target.closest('.cookie-cat');
    if (!label) return;
    const cb = label.querySelector('input[type=checkbox]');
    if (!cb || cb.disabled) return;
    cb.checked = !cb.checked;
    label.classList.toggle('is-on', cb.checked);
  });

  // Re-open from footer link
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cookie-reopen]')) {
      localStorage.removeItem(KEY);
      show();
    }
  });

  // Pixel loader — fired in response to consent
  window.addEventListener('cookie-consent', (e) => {
    const { analytics, marketing } = e.detail || {};
    document.querySelectorAll('script[data-consent="analytics"][data-src]').forEach((s) => {
      if (analytics && !s.src) s.src = s.dataset.src;
    });
    document.querySelectorAll('script[data-consent="marketing"][data-src]').forEach((s) => {
      if (marketing && !s.src) s.src = s.dataset.src;
    });
  });
})();
